<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Edit Client
                    </div>
                    <div class="card-block">
                        <div class="row mt-1">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Name *</label>
                                        <input type="text" class="form-control" v-model="edit_client.name" placeholder="Enter name"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Title</label>
                                        <input type="text" class="form-control" v-model="edit_client.title" placeholder="Enter title"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Registration number</label>
                                        <input type="text" class="form-control" v-model="edit_client.reg_id" placeholder="Enter registration number"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Vat number</label>
                                        <input type="text" class="form-control" v-model="edit_client.vat_nr" placeholder="Enter vat nr"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Legal address</label>
                                        <input type="text" class="form-control" v-model="edit_client.legal_address" placeholder="Enter legal address"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Actual address</label>
                                        <input type="text" class="form-control" v-model="edit_client.actual_address" placeholder="Enter actual address"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Bank name</label>
                                        <input type="text" class="form-control" v-model="edit_client.bank_name" placeholder="Enter bank name"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Bank account</label>
                                        <input type="text" class="form-control" v-model="edit_client.bank_account" placeholder="Enter bank account"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Bank swift number</label>
                                        <input type="text" class="form-control" v-model="edit_client.bank_swift" placeholder="Enter bank swift number"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Phone number</label>
                                        <input type="text" class="form-control" v-model="edit_client.phone_nr" placeholder="Enter phone number"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Email</label>
                                        <input type="text" class="form-control" v-model="edit_client.email" placeholder="Enter email"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label class="vcentered-text">Signatory name</label>
                                        <input type="text" class="form-control" v-model="edit_client.signatory_name" placeholder="Enter signatory full name"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="vcentered-text">Signatory position</label>
                                        <input type="text" class="form-control" v-model="edit_client.signatory_position" placeholder="Enter signatory position"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                            <div class="divTable">
                                <div class="divTableBody">
                                    <div class="divTable">
                                        <div class="divTableHeading">
                                            <div class="divTableCell">Contract name</div>
                                            <div class="divTableCell">Contract status</div>
                                            <div class="divTableCell">Contract number</div>
                                            <div class="divTableCell">Contract type</div>
                                            <div class="divTableCell">Contract date</div>
                                            <div class="divTableCell">Attachments</div>
                                            <div class="divTableCell">Options</div>
                                        </div>
                                        <div class="divTableBody" v-if="edit_client.contracts.length" v-for="contract in edit_client.contracts">
                                            <div class="divTableRow">
                                                <div class="divTableCell divTableContractHeading">{{contract.contract_name}}</div>
                                                <div class="divTableCell divTableContractHeading">{{removeUnderscore(contract.contract_status)}}</div>
                                                <div class="divTableCell divTableContractHeading">{{contract.contract_number}}</div>
                                                <div class="divTableCell divTableContractHeading">{{removeUnderscore(contract.document_type)}}</div>
                                                <div class="divTableCell divTableContractHeading">{{contract.contract_date}}</div>
                                                <div class="divTableCell divTableContractHeading">&nbsp;</div>
                                                <div class="divTableCell divTableContractHeading">

                                                    <button v-if="contract.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                                      title="Print contract PDF" @click="download({newTab:true, url:'/api/print_contract', params:{contract_id:contract.id}},`${filenameFilter(contract.contract_name)}.pdf`)"></button>

                                                    <button v-if="contract.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-word-o fa-lg action"
                                                      title="Print contract Docx" @click="download({url:'/api/print_contract_to_msword', params:{contract_id:contract.id}},`${filenameFilter(contract.contract_name)}.docx`)"></button>

                                                    <button v-if="contract.contract_type == 'imported'" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                                      title="Download contract" @click="download({url:'/api/print_contract_imported', params:{contract_id:contract.id}})"></button>

                                                    <i class="fa fa-edit fa-lg action" @click="editContract(contract)" rel="tooltip" title="Edit contract"></i>
                                                    <i class="fa fa-trash fa-lg action" @click="deleteContract(contract)" rel="tooltip" title="Delete contract"></i>
                                                </div>
                                            </div>
                                            <div class="divTableRow" v-if="contract.appendixes.length" v-for="appendix in contract.appendixes">
                                                <div class="divTableCell">&nbsp;</div>
                                                <div class="divTableCell">&nbsp;</div>
                                                <div class="divTableCell">&nbsp;</div>
                                                <div class="divTableCell">&nbsp;</div>
                                                <div class="divTableCell">&nbsp;</div>
                                                <div class="divTableCell">

                                                    <button style="border: none; background-color: inherit;" class="btn-link"
                                                      title="Download file" @click="download({url:'/api/print_appendix', params:{file_id:appendix.id}})">
                                                      {{appendix.file_name}}
                                                    </button>

                                                    <!-- <form style="display: inline;" action="/print_appendix" target="_blank">
                                                        <input type="hidden" name="file_id" :value="appendix.id">
                                                        <button style="border: none; background-color: inherit;" type="submit" class="btn-link" rel="tooltip" title="Download file">{{appendix.file_name}}</button>
                                                    </form> -->
                                                    <i class="fa fa-trash fa-lg action" @click="deleteFile(appendix)" rel="tooltip" title="Delete file"></i>
                                                </div>
                                                <div class="divTableCell">&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="col-md-3 pull-right text-right">
                                    <button type="button" class="btn btn-primary" @click="updateClient()">Save</button>
                                    <button type="button" class="btn btn-secondary" @click="cancelEdit()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueNotifications from 'vue-notifications';
import modal from 'vue-strap/src/Modal';
import { download, filenameFilter } from '@/_axios';

export default {
  name: 'clients',
  components: {
    modal
  },
  data() {
    return {
      download: download,
      filenameFilter: filenameFilter,
      edit_client: {
        name: '',
        title: '',
        reg_id: '',
        vat_nr: '',
        legal_address: '',
        actual_address: '',
        bank_name: '',
        bank_account: '',
        bank_swift: '',
        phone_nr: '',
        email: '',
        signatory_position: '',
        signatory_name: ''
      },
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
    };
  },
  watch: {
    client_updated: function (val) {
      if (this.client_updated.status == 'success') {
        this.showSuccessMsg({ title: 'Client update status', message: `Client ${this.client_updated.data.name} updated!` });
        this.$router.push({ name: 'Clients' });
      }
      if (this.client_updated.status == 'error') {
        for (const i in this.client_updated.message) {
          this.showErrorMsg({ title: 'Client update status', message: this.client_updated.message[i] });
        }
      }
    },
    deleted_file: function (val) {
      if (this.deleted_file.status == 'success') {
        this.showSuccessMsg({ title: 'File delete status', message: this.deleted_file.message });
        for (let i = 0; i < this.edit_client.contracts.length; i++) {
          let appendixFound = false;
          for (let j = 0; j < this.edit_client.contracts[i].appendixes.length; j++) {
            if (this.edit_client.contracts[i].appendixes[j].id == this.deleted_file.data) {
              appendixFound = true;
              this.edit_client.contracts[i].appendixes.splice(j, 1);
              break;
            }
          }
          if (appendixFound) break;
        }
      }
      if (this.deleted_file.status == 'error') {
        this.showErrorMsg({ title: 'File delete status', message: this.deleted_file.message });
      }
    },
    deleted_contract: function (val) {
      if (this.deleted_contract.status == 'success') {
        this.showSuccessMsg({ title: 'Contract delete status', message: `Contract ${this.deleted_contract.data.contract_name} deleted!` });
        for (let i = 0; i < this.edit_client.contracts.length; i++) {
          if (this.edit_client.contracts[i].id == this.deleted_contract.data.id) {
            this.edit_client.contracts.splice(i, 1);
          }
        }
      }
      if (this.deleted_contract.status == 'error') {
        this.showErrorMsg({ title: 'Contract delete status', message: this.deleted_contract.message });
      }
    }
  },
  computed: {
    ...mapGetters('Clients', [
      'client_updated',
      'deleted_file',
      'deleted_contract'
    ])
  },
  methods: {
    ...mapActions('Clients', [
      'UPDATE_CLIENT',
      'GET_CLIENT',
      'DELETE_CONTRACT',
      'DELETE_FILE'
    ]),
    updateClient() {
      this.UPDATE_CLIENT(this.edit_client);
    },
    cancelEdit() {
      this.$router.push({ name: 'Clients' });
    },
    getClientData() {
      this.GET_CLIENT(this.$route.params.id).then((response) => {
        this.edit_client = response.data.data;
        this.edit_client.contracts = this.edit_client.contracts.sort((a, b) => { return (a.contract_date < b.contract_date) ? 1 : ((b.contract_date < a.contract_date) ? -1 : 0); });
      }, (err) => {
        console.log(err);
      });
    },
    editContract(contract) {
      this.$router.push({ name: 'EditContract', params: { id: contract.id } });
    },
    deleteContract(contract) {
      const vm = this;
      this.$dialog.confirm(`Delete contract - ${contract.contract_name}?`, this.confirmation_options).then(() => {
        vm.DELETE_CONTRACT(contract.id);
      }).catch(() => {

      });
    },
    deleteFile(file) {
      const vm = this;
      this.$dialog.confirm(`Delete file - ${file.file_name}?`, this.confirmation_options).then(() => {
        vm.DELETE_FILE(file.id);
      }).catch(() => {

      });
    },
    removeUnderscore(string) {
      let text = string.replace('_', ' ');
      text = text.charAt(0).toUpperCase() + text.slice(1);
      text.split('_').join(' ');
      return text;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.getClientData();
  }
};
</script>

<style lang="scss" scope>
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }

    .dg-btn--ok:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--ok:disabled,
    .dg-btn--ok.is-disabled {
        opacity: .5;
    }

    .dg-btn--cancel {
        color: #263238;
        background-color: #fff;
        border-color: #b0bec5;
        border-radius: var(--border-radius);
    }

    .dg-btn--cancel:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #e6e5e5;
        border-color: #8da1ab;

    }

    .dg-btn--cancel:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--cancel:disabled,
    .dg-btn--cancel.is-disabled {
        opacity: .5;
    }

    .divTable{
        display: table;
        width: 100%;
    }
    .divTableRow {
        display: table-row;
    }
    .divTableCell, .divTableHead {
        border: 1px solid #999999;
        display: table-cell;
        padding: 3px 10px;
    }
    .divTableHeading {
        background-color: #b6b6b6;
        color: #fff;
        display: table-header-group;
        font-weight: bold;
    }
    .divTableContractHeading {
        background-color: #e3e3e3;
    }
    .divTableFoot {
        background-color: #EEE;
        display: table-footer-group;
        font-weight: bold;
    }
    .divTableBody {
        display: table-row-group;
    }
    .btn-link{
        border:none;
        outline:none;
        background:none;
        cursor:pointer;
        color: #263238;
        padding:0;
        text-decoration:none;
        font-family:inherit;
        font-size:inherit;
    }

</style>
